import React from 'react'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Form, Modal, Button, Spin, Icon, Input} from "antd"
import {createAdvanceWithdraw} from "../../../actions/WithdrawAction";

class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    showWithdrawModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    handleSubmit = (form) => {

        //Validate completed data
        form.validateFields((err, values) => {

            const createAdvanceWithdrawData = {
                affiliateId: this.props.affId,
                amount: values.amount
            };

            if (!err) {
                this.props.dispatch(createAdvanceWithdraw(createAdvanceWithdrawData, this.props.intl)).then(
                    (status) => {
                        if (status !== "error") {
                            this.setState({
                                visible: false
                            });
                        }
                    })
            }
        });
    };

    render() {

        const {getFieldDecorator} = this.props.form;

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin/>;

        return (
            <React.Fragment>

                <Button className='clear_button_style' onClick={this.showWithdrawModal}>
                    {this.props.intl.messages.advance_withdraw}
                </Button>

                {/* Settings Modal */}
                <Modal
                    title={this.props.intl.messages.advance_withdraw}
                    visible={this.state.visible}
                    centered
                    onCancel={this.handleCancel}
                    footer={[
                        <React.Fragment>
                            <Button onClick={this.handleCancel} key="next">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.handleSubmit.bind(this, this.props.form)} key="save"
                                    type="primary">{this.props.intl.messages.save}</Button>
                        </React.Fragment>
                    ]}
                >

                    <Spin indicator={antIcon} spinning={this.props.affiliates.inProcess}>
                        <Form layout="vertical" className='ta--ph-12 ta-w100'>

                            <Form.Item label={this.props.intl.messages.amount}>
                                {getFieldDecorator("amount", {})(
                                    <Input autoComplete="off"/>
                                )}
                            </Form.Item>

                        </Form>
                    </Spin>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Settings)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Affiliates/AdvanceWithdraw.js